export const CurrentDay = {
  transclude: true,

  bindings: {
    type: '@',
  },

  template: `
    <span class="current-day">
      {{ $ctrl.today | date: $ctrl.key }}
      <ng-transclude></ng-transclude>
    </span>`,

  controller() {
    'ngInject';

    return {
      $onInit() {
        this.today = new Date();
        this.key = this.type === 'short' ? 'EEE' : 'EEEE';
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/CurrentDay/CurrentDay.js